export default __webpack_public_path__ + "static/media/ic_notification.7985403b.svg";